import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import { useIsSkipifyAdmin } from '../../../hooks';
import { getPortalUserRoleCatalogForReference } from '../portalUserRoleCatalog';

const roleColumnSx = {
  width: '28%',
  minWidth: 240,
  verticalAlign: 'top',
  pr: 2,
  borderRight: 1,
  borderColor: 'divider',
};

export const RolePermissionsReference = () => {
  const isSkipifyAdmin = useIsSkipifyAdmin();
  const roles = getPortalUserRoleCatalogForReference(isSkipifyAdmin);

  return (
    <Paper variant="outlined">
      <TableContainer>
        <Table
          size="small"
          aria-label="Portal user roles"
          sx={{ tableLayout: 'fixed', width: '100%' }}
        >
          <TableHead>
            <TableRow>
              <TableCell sx={roleColumnSx}>Role</TableCell>
              <TableCell sx={{ verticalAlign: 'top' }}>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {roles.map((role) => (
              <TableRow key={role.name}>
                <TableCell sx={roleColumnSx}>
                  <Typography variant="body2" fontWeight={600}>
                    {role.label}
                  </Typography>
                </TableCell>
                <TableCell sx={{ verticalAlign: 'top' }}>
                  <Typography variant="body2">{role.description}</Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
